export default __webpack_public_path__ + "static/media/audi.6b272334.svg";